import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../style/policy.css";

const ReturnPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  return (
    <div className="policy-container">
      <button className="policy-back-btn" onClick={() => navigate("/")}>
        Back
      </button>
      <h1>Return Policy</h1>
      <div className="policy-content">
        <p>
          GR GPT is a digital information platform. It does not sell physical goods, fulfill
          orders, or provide e-commerce returns, exchanges, or shipping services.
        </p>

        <h2>No Returns or Order Processing</h2>
        <p>
          Because GR GPT is a software and information service, order-related policies such as
          product returns, exchanges, shipping claims, and warehouse inspections do not apply.
        </p>

        <h2>Permitted Use</h2>
        <ul>
          <li>Use GR GPT to search, review, and understand government resolutions and related information.</li>
          <li>Verify important decisions against the original source documents before acting.</li>
          <li>Use the service responsibly and in compliance with applicable laws and workplace policies.</li>
        </ul>

        <h2>Prohibited Use</h2>
        <ul>
          <li>Do not use the service to spread misinformation or fake government directives.</li>
          <li>Do not attempt to scrape, overload, or attack the platform.</li>
          <li>Do not submit unlawful, abusive, or malicious content.</li>
        </ul>

        <h2>Subscriptions and Digital Access</h2>
        <p>
          If GR GPT offers paid plans, credits, or account-based access, those are digital
          service features, not physical purchases. Access, renewal, and billing terms are
          governed by the platform’s service rules and applicable payment flow.
        </p>

        <h2>Service Changes</h2>
        <p>
          We may update, improve, limit, or discontinue features of GR GPT at any time to
          support product quality, safety, or operational needs.
        </p>

        <h2>Support</h2>
        <p>
          For account, billing, or service questions, visit our <Link to="/contact">Contact Support</Link> page or email <strong>grgptsupport@gmail.com</strong>.
        </p>
      </div>
    </div>
  );
};

export default ReturnPolicy;
